import { render, staticRenderFns } from "./file.vue?vue&type=template&id=61a8818f&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a8818f",
  null
  
)

export default component.exports